import type React from 'react';

import { Radio, RadioGroup } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	paymentTerm: 'one-time' | 'monthly' | 'yearly';
	name: string;
	showYearlyPaymentTerm: boolean;
	showOneTimePaymentTerm: boolean;
	onChange: (value: string) => void;
};

export const MembershipPaymentTermSelector: React.FC<Props> = ({
	paymentTerm,
	onChange,
	name,
	showYearlyPaymentTerm,
	showOneTimePaymentTerm,
}) => {
	const { translate } = useI18n();

	if (!showYearlyPaymentTerm && !showOneTimePaymentTerm) return null;

	return (
		<div className="pb-4">
			<RadioGroup
				id={name}
				name={name}
				data-qa="payment-term-selector"
				label=""
				aria-label={translate('corgi.membership.payment_form.terms.a11y.label')}
				labelIsVisible={false}
				orientation="horizontal"
				value={paymentTerm}
				onChange={onChange}
			>
				{!!showOneTimePaymentTerm && (
					<Radio value="one-time" data-testid={`${name}-one-time-radio`}>
						{translate('corgi.membership.payment_form.terms.one_time')}
					</Radio>
				)}
				<Radio value="monthly" data-testid={`${name}-monthly-radio`}>
					{translate('corgi.membership.payment_form.terms.monthly')}
				</Radio>
				{!!showYearlyPaymentTerm && (
					<Radio value="yearly" data-testid={`${name}-yearly-radio`}>
						{translate('corgi.membership.payment_form.terms.yearly')}
					</Radio>
				)}
			</RadioGroup>
		</div>
	);
};
